import React, {useEffect, useState, useCallback} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { Pagination } from "../../../../component/paging";
import { Page } from "../../../../interface/model/page";
import { NoticeInfoDTO, createNoticeInfoDTO } from '../../../../interface/model/board';
import { FileInfo } from "../../../../interface/model/file";
import { makeStyles } from '@material-ui/core/styles';

import TableContainer from '@material-ui/core/TableContainer';
import Api from "../../../../interface/api/content"
import FileApi from '../../../../interface/api/file';
import {ManagementMenuOptionItem, ManagementMenuOptionItem2} from "../../../../component/menu-item";
import Paper from '@material-ui/core/Paper';

const ButtonStyle = {
    display: 'inline-block',
    height: '33px',
    padding: '0 15px',
    fontSize: '13px',
    lineHeight: '33px',
    verticalAlign: 'middle',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '5px',
    color:'#fff',
    background: '#3280ff'
}

export default function Notice() {
    const siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
    const initBoardInfo = {...createNoticeInfoDTO, siteInfoSeq : siteInfo.seq};

    const [ noticeInfos, setNoticeInfos ] = useState<Page>();
    const [ selectedNoticeInfo, setSelectedNoticeInfo ] = useState<NoticeInfoDTO>(null);
    const [ fileInfo, setFileInfo ] = useState<FileInfo>(null);

    const [ pageNumber, setPageNumber ] = useState<number>(0);
    const [ searchInfo , setSearchInfo ] = useState({
        boardSearchType : 'all',
        searchValue : ''
    });


    function modeHandler(boardInfo) {
        setSelectedNoticeInfo(boardInfo);
        // Api.getBoardInfos("BOARD", siteInfo.seq).then(res => setNoticeInfos(res.data));
    }

    function insertHandler() {
        if( selectedNoticeInfo.boardInfoSeq !== null ) Api.updateBoardInfo({...selectedNoticeInfo, fileInfo : fileInfo !== null ? fileInfo : null});
        else Api.createBoardInfo({...selectedNoticeInfo, fileInfo : fileInfo});

        alert('정상적으로 처리되었습니다.');
        Api.getBoardInfosBySearchAndPage("BOARD", siteInfo.seq, searchInfo, pageNumber).then(res => {
            setSelectedNoticeInfo(null);
            setNoticeInfos(res.data)
        });
    }

    function modifyHandler(boardInfo) {
        Api.getSelectBoardInfo(boardInfo.seq).then(res => setSelectedNoticeInfo(res.data));
    }

    function deleteHandler(boardInfo) {
        Api.deleteBoardInfo(boardInfo.seq).then(() => {
            alert('정상적으로 처리되었습니다.');
            Api.getBoardInfosBySearchAndPage("BOARD", siteInfo.seq, searchInfo, pageNumber).then(res => setNoticeInfos(res.data));
        });
    }

    function fileOnChange(e) {
        let fileArray = new Array();
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            fileArray.push(files[i]);
        }
        FileApi.createFileInfo('BOARD', fileArray).then(res => {
            setFileInfo(res.data);
            setSelectedNoticeInfo({...selectedNoticeInfo, fileInfo : res.data});
        });

    }

    function deleteFile() {
        FileApi.deleteFileInfo(fileInfo.seq).then(res => {
            setFileInfo(null);
        });
    }


    return (
        <div className="nv_contents">
            {
                selectedNoticeInfo !== null ?
                    <>
                        <Insert selectedNoticeInfo={selectedNoticeInfo}
                                setSelectedNoticeInfo={setSelectedNoticeInfo}
                                fileOnChange={fileOnChange}
                                deleteFile={deleteFile} />
                        <div className="btn_area nv_page_bottomarea_type2">
                            <button type="button" className="nv_green_button m_w_100" style={{marginLeft:'5px'}}  onClick={() => modeHandler(null)}>취소</button>
                            <button type="submit" className="nv_blue_button m_w_100" onClick={insertHandler}>저장</button>
                        </div>
                    </> :
                    <>
                        <List siteInfo = { siteInfo }
                              noticeInfos = { noticeInfos }
                              setNoticeInfos = { setNoticeInfos }
                              searchInfo = { searchInfo }
                              setSearchInfo = { setSearchInfo }
                              pageNumber = { pageNumber }
                              modifyHandler = { modifyHandler }
                              deleteHandler = { deleteHandler } />
                        <div className="nv_table_box nv_m_btn_area nv_bord_btn_area">
                            <button type="button" className="nv_blue_button right"
                                    onClick={() => modeHandler(initBoardInfo)}>작성
                            </button>
                        </div>
                    </>
            }
        </div>
    )
}

function List({ siteInfo, noticeInfos, setNoticeInfos, searchInfo, setSearchInfo, pageNumber, modifyHandler, deleteHandler }) {

    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: '1px solid #e1e1e1',
            },
        },
    });
    const classes = useRowStyles();

    function searchHandler() {
        if(searchInfo.searchValue !== '') {
            const siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
            Api.getBoardInfosBySearchAndPage("BOARD", siteInfo.seq, searchInfo, pageNumber).then(res => setNoticeInfos(res.data));
        }
    }

    function pageMoveHandler(pageNumber) {
        Api.getBoardInfosBySearchAndPage("BOARD", siteInfo.seq, searchInfo, pageNumber).then(res => setNoticeInfos(res.data));
    }

    function submit(e) {
        e.preventDefault();
        searchHandler();
    }

    useEffect(() => {
        Api.getBoardInfosBySearchAndPage("BOARD", siteInfo.seq, searchInfo, pageNumber).then(res => {
            setNoticeInfos(res.data)
        });
    }, [])

    return(
        <>
            <form onSubmit={submit}>
                <div className="nv_contents_search">
                    <div className="nv_select_box">
                        <p id="conditionKey">
                            {searchInfo.boardSearchType == 'all' && '전체'}
                            {searchInfo.boardSearchType == 'title' && '제목'}
                            {searchInfo.boardSearchType == 'contents' && '내용'}
                        </p>
                        <ul>
                            <li onClick={() => setSearchInfo({...searchInfo, boardSearchType: 'all'})}>전체</li>
                            <li onClick={() => setSearchInfo({...searchInfo, boardSearchType: 'title'})}>제목</li>
                            <li onClick={() => setSearchInfo({...searchInfo, boardSearchType: 'contents'})}>내용</li>
                        </ul>
                    </div>
                    <div className="nv_search_box">
                        <input type="text" className="nv_input" id="conditionValue" title="Search" onChange={(e) => setSearchInfo({...searchInfo, searchValue: e.target.value})}/>
                        <input type="submit" className="nv_search_icon tpc_skip m_skip" title="search"/>
                    </div>
                    <div className="nv_search_box pc_skip tpc_skip" style={{width:"32px;"}}>
                        <input type="submit" className="nv_search_icon" title="search"/>
                    </div>
                </div>
            </form>
            <div className="nv_table_box">
                <TableContainer component={Paper}>
                    <table className="nv_table textcenter nv_board_table" id="noticeTable">
                        <colgroup>
                            <col style={{width:'70%'}} />
                            {/* <col style={{width:'15%'}} /> */}
                            <col style={{width:'30%'}} />
                        </colgroup>
                        <thead>
                        <tr>
                            <th scope="row">제목</th>
                            {/* <th scope="row">첨부파일</th> */}
                            <th scope="row">관리</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            noticeInfos !== undefined && noticeInfos.content.length > 0
                            ?
                                noticeInfos.content.map((noticeInfo, index) => (
                                    <tr key={`noticeInfoKey-${index}`}>
                                        <td>{noticeInfo.title}</td>
                                        {/* <td>{noticeInfo.title}</td> */}
                                        <td>
                                            <ManagementMenuOptionItem items={[
                                                {
                                                    innerHTML:'수정',
                                                    onClickHandler:() => modifyHandler(noticeInfo)
                                                },
                                                {
                                                    innerHTML:'삭제',
                                                    onClickHandler:() => deleteHandler(noticeInfo)
                                                }
                                            ]}/>
                                        </td>
                                    </tr>
                                ))
                            :
                                <tr>
                                    <td colSpan={2}>등록된 공지사항이 존재하지 않습니다.</td>
                                </tr>

                        }
                        </tbody>
                    </table>
                </TableContainer>
                <div className="nv_table_pagenum" id="pagenation">
                    <Pagination page={ noticeInfos } pageMoveHandler={ pageMoveHandler } />
                </div>
            </div>
        </>
    )
}

function Insert({selectedNoticeInfo, setSelectedNoticeInfo, fileOnChange, deleteFile}) {

    const modules = {
        toolbar: [
          [{ 'header': [1, 2, false] }],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
          ['link', 'image'],
          [{ 'align': [] }, { 'color': [] }, { 'background': [] }],
          ['clean']
        ],
      }
    
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image',
        'align', 'color', 'background',        
      ]

    return(
        <>
            <div className="nv_table_tit nv_wirte_tit">
                <h4>공지사항 작성</h4>
                <p><span className="nv_red">*</span> 는 필수 입력 사항입니다.</p>
            </div>
            <table className="nv_table nv_write_table">
                <colgroup>
                    <col width={'20%'}/>
                    <col/>
                </colgroup>
                <tbody>
                    <tr>
                        <td className="nv_bold textcenter"><span className="nv_red">*</span>제목</td>
                        <td>
                            {
                                selectedNoticeInfo.title != null ?
                                <input type="text"
                                        className="nv_input"
                                        name="title"
                                        value={selectedNoticeInfo.title}
                                        onChange={(e) => setSelectedNoticeInfo({...selectedNoticeInfo, title: e.target.value})}
                                /> :
                                <input type="text"
                                        className="nv_input"
                                        name="title"
                                        placeholder="제목을 입력해주세요."
                                        onChange={(e) => setSelectedNoticeInfo({...selectedNoticeInfo, title: e.target.value})}
                                />
                            }
                        </td>
                    </tr>
                    <tr>
                        <td className="nv_bold textcenter"><span className="nv_red">*</span>내용</td>
                        <td>
                            <ReactQuill style={{width: '100%', height: "350px", overflow:'auto', listStyle:'none'}}
                                modules={modules}
                                formats={formats}
                                value={selectedNoticeInfo.contents || ''}
                                onChange={(content, delta, source, editor) => setSelectedNoticeInfo({...selectedNoticeInfo, contents : editor.getHTML()})} 
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="nv_bold textcenter">첨부파일</td>
                        {
                            selectedNoticeInfo.fileInfo === undefined || selectedNoticeInfo.fileInfo === null
                                ?   <td>
                                        <input type="file"
                                                id="insertFile"
                                                style={{display:"none"}}
                                                onChange={fileOnChange}
                                                required={true}
                                                multiple/>
                                        <label htmlFor="insertFile" style={ButtonStyle}>
                                            파일선택
                                        </label>
                                    </td>
                                :   <td>
                                        {selectedNoticeInfo.fileInfo.fileName}
                                        <button type="button"
                                            className="nv_red_button minus"
                                            onClick={deleteFile}>삭제
                                        </button>
                                    </td>
                        }
                    </tr>
                </tbody>
            </table>
        </>
    )
}